import { useOptOutService as useGeneratedOptOutService } from "../../cbi-generator/frontend/composables/useOptOutFrontendService";
import type { OptOutGroupStatus } from "../../cbi-generator/generated/dto/OptOutGroupStatus";
import type { OptOutStatus } from "../../cbi-generator/generated/dto/OptOutStatus";

export interface OptOutService {
  optOutUpdatePost: (request: {
    token: string;
    doNotSend: boolean;
  }) => Promise<OptOutGroupStatus>;
  memberOptOutStatusGet: () => Promise<OptOutStatus>;
  memberOptOutStatusPost: (
    optOutGrpId: number,
    doNotSend: boolean,
  ) => Promise<OptOutStatus>;
}

export const useOptOutService = (): OptOutService => {
  const service = useGeneratedOptOutService();

  const optOutUpdatePost = async (request: {
    token: string;
    doNotSend: boolean;
  }): Promise<OptOutGroupStatus> => {
    return service.updateOptOutTokenPublic(request);
  };

  const memberOptOutStatusGet = async (): Promise<OptOutStatus> => {
    return service.memberOptOutStatusMember();
  };

  const memberOptOutStatusPost = async (
    optOutGrpId: number,
    doNotSend: boolean,
  ): Promise<OptOutStatus> => {
    return service.setMemberOptOutMember({ group: { optOutGrpId }, doNotSend });
  };

  return {
    optOutUpdatePost,
    memberOptOutStatusGet,
    memberOptOutStatusPost,
  };
};
